/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Category_OtherInputs */

const en_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const fr_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const es_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const it_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

const nl_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overig`)
};

const pl_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inne`)
};

const fi_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muu`)
};

const da_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andet`)
};

const sv_feedback_category_other = /** @type {(inputs: Feedback_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Övrigt`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Feedback_Category_OtherInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_category_other = /** @type {((inputs?: Feedback_Category_OtherInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Category_OtherInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_category_other(inputs)
	if (locale === "fr") return fr_feedback_category_other(inputs)
	if (locale === "es") return es_feedback_category_other(inputs)
	if (locale === "it") return it_feedback_category_other(inputs)
	if (locale === "nl") return nl_feedback_category_other(inputs)
	if (locale === "pl") return pl_feedback_category_other(inputs)
	if (locale === "fi") return fi_feedback_category_other(inputs)
	if (locale === "da") return da_feedback_category_other(inputs)
	if (locale === "sv") return sv_feedback_category_other(inputs)
	return en_feedback_category_other(inputs)
});